import { usePipelineCoordinator } from './usePipelineCoordinator'
import type { UseImagePipelineOptions, UseImagePipelineResult } from '@/types/pipeline'

/**
 * 配图生成流水线 Hook
 * 封装单笔记/批量配图的完整流程
 * 
 * 此 Hook 现在是 usePipelineCoordinator 的轻量级封装，
 * 逻辑已拆分至 Planner, Generator 和 Coordinator 子 Hook 中。
 */
export function useImagePipeline(options: UseImagePipelineOptions): UseImagePipelineResult {
  const { runSmartImages, runBulkImages, flushWrites } = usePipelineCoordinator(options)

  return {
    runSmartImages,
    runBulkImages,
    flushWrites,
  }
}
